export default __webpack_public_path__ + "static/media/case-8.0940e4ea.png";